/**
 * Для простоты обработки держим типы как константы
 * (строгое соответствие API)
 */
export const AttributeTypes = {
  button: 'button',
  string: 'string',
  integer: 'integer',
  fixedPointNumber: 'float',
  realNumber: 'real',
  dateAndTime: 'dateTime',
  time: 'time',
  date: 'date',
  text: 'text',
  textWithHeader: 'textWithHeader',
  file: 'file',
  image: 'image',
  groupOfImages: 'groupOfImages',
  list: 'list',
  radioButton: 'radioButton',
  spam: 'spam',
  entity: 'entity',
  timeInterval: 'timeInterval',
  json: 'json'
};

/**
 * Типы атрибутов, значения которых (listTitles) хранятся внутри самого
 * атрибута и локализуются отдельно — НЕ в attributesSets сущности.
 * См. docs/specs/copy-localization-modal-complex-attr-hint-2026-04-23.md
 */
export const LOCALIZED_VALUE_ATTRIBUTE_TYPES = [
  AttributeTypes.list,
  AttributeTypes.radioButton,
  AttributeTypes.entity,
];

export const AttributeTypeImportId = {
  string: 1,
  integer: 2,
  fixedPointNumber: 3,
  realNumber: 4,
  dateAndTime: 5,
  time: 6,
  date: 7,
  text: 8,
  textWithHeader: 9,
  file: 10,
  image: 11,
  groupOfImages: 12,
  list: 14,
  radioButton: 13,
  spam: 15,
  button: 16,
  entity: 17,
  timeInterval: 18,
  json: 19
};
